<template>
	<div class="ruleBox">
		<navBar>{{ title }}</navBar>
		<div class="content-box font26">
			<div v-html="dataList.content"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '赚币规则',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			dataList: {}
		};
	},
	created() {this.getshoplist()},
	methods: {
		getshoplist() {
			this.$api.getbannerlist({ isshop: 1 }).then((res) => {
				this.dataList = res.data[0];
			});	
		},
		goPage() {
			this.$router.push({
				path: '/chapter',
				query: {
					id: 45,
					name: 'name',
					active: 1
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.ruleBox {
	
	background: #F5FAFF;
	.content-box{
		height: calc(100% - 1.08rem);
		overflow: auto;
		// padding: 0.34rem 0.28rem 0.25rem 0.28rem;
		position: fixed;
		left: 0;
		right: 0;
		top: 1.08rem;
		background: #F5FAFF;
	}
}
</style>
